import * as React from 'react';
import { Props } from './../types/types';
import { View } from './../libs/WebComponents';

const ProgressBar = (props: Props)=>{

   const [finished, setFinished] = React.useState(false);

   let progress = props.index / (props.total);
   if (Number.isNaN(progress)) {
      progress = 0;
   }else{
      progress = progress * 100;
   }

   React.useEffect(()=>{
      setTimeout(()=>setFinished(props.index === props.total), 1500);
   },[props.index]);

   return (
      <View className={`progress-bar ${finished?'finished':''}`}>
         <View className='bar' style={{width: progress+'%'}} />
      </View>
   );
}

export default React.memo(ProgressBar);